"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var repositoryAdmin;
        (function (repositoryAdmin) {
            var clientInstall;
            (function (clientInstall) {
                function init() {
                    const $appnForm = $('#appnForm');
                    appn.iframe.bindSubmitButtonsAndNavLinks($appnForm);
                    const selectedItems = parent.appn.views.repositoryAdmin.index.selectedItems;
                    selectedItems.each(function (index, item) {
                        $('#appnForm').append('<input type="hidden" name="SelectedItems[' + index + ']" value="' + $(item).prop('id') + '" />');
                    });
                    addEvents();
                }
                clientInstall.init = init;
                function addEvents() {
                    $('.switch-install-method').on('click', function (event) {
                        event.preventDefault();
                        if (event && event.target.classList.contains('linked'))
                            unlinkedInstall();
                        if (event && event.target.classList.contains('unlinked'))
                            linkedInstall();
                    });
                    $('.chk-keep-in-sync').on('change', function (event) {
                        const currentValue = $(this).is(':checked');
                        $('#appnForm input[name="KeepInSync"]').remove();
                        $('#appnForm').append(`<input type="hidden" name="KeepInSync" value="${currentValue}" />`);
                    });
                }
                function linkedInstall() {
                    $('#IsIntegrationInstall').removeAttr('checked');
                    $('#IsIntegrationInstall').attr('value', 'false');
                    $('#CompanyId').val(appn.emptyString);
                    $('#IntegrationKey').val(appn.emptyString);
                    const thisBoxTypeList = $('div.unlinked');
                    thisBoxTypeList.each(function (index, currentBox) {
                        const boxParent = currentBox.parentElement;
                        boxParent.classList.add('d-none');
                    });
                    const otherBoxTypeList = $('div.linked');
                    otherBoxTypeList.each(function (index, currentBox) {
                        const boxParent = currentBox.parentElement;
                        boxParent.classList.remove('d-none');
                    });
                }
                function unlinkedInstall() {
                    $('#IsIntegrationInstall').attr('checked', 'true');
                    const thisBoxTypeList = $('div.linked');
                    thisBoxTypeList.each(function (index, currentBox) {
                        const boxParent = currentBox.parentElement;
                        boxParent.classList.add('d-none');
                    });
                    const otherBoxTypeList = $('div.unlinked');
                    otherBoxTypeList.each(function (index, currentBox) {
                        const boxParent = currentBox.parentElement;
                        boxParent.classList.remove('d-none');
                    });
                }
            })(clientInstall = repositoryAdmin.clientInstall || (repositoryAdmin.clientInstall = {}));
        })(repositoryAdmin = views.repositoryAdmin || (views.repositoryAdmin = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
